import { QueryHookOptions } from '@apollo/client';
import { EMPTY_ALERT_STATE } from 'modules/campaigns/alerts/constants';
import { useMemo, useState } from 'react';
import { SavedAlertsByMedium } from '../types';
import { useProjectCampaignAlertsQuery } from './useProjectCampaignAlertsQuery';

export const useGetProjectCampaignAlerts = (options: QueryHookOptions = {}) => {
  const [savedAlerts, setSavedAlerts] = useState<SavedAlertsByMedium>(EMPTY_ALERT_STATE);

  const queryOptions = useMemo(
    () => ({
      onCompleted: (data: { projectCampaignAlerts: SavedAlertsByMedium }) => {
        const { projectCampaignAlerts } = data;
        setSavedAlerts(projectCampaignAlerts);
      },
      ...options,
    }),
    [],
  );
  const { isLoading: isLoadingProjectCampaignAlerts } = useProjectCampaignAlertsQuery(queryOptions);

  return {
    savedAlerts,
    setSavedAlerts,
    isLoadingProjectCampaignAlerts,
  };
};
